import React,{createContext,useContext} from 'react';
import {createPortal} from 'react-dom';

export const StatisticsHeaderContext=createContext(null);

// Keep each page's controls with its state, while rendering them in the common header.
export default function StatisticsHeaderActions({children}) {
  const target=useContext(StatisticsHeaderContext);
  const controls=<div className="StatisticsHeaderActions">{children}</div>;
  return target?createPortal(controls,target):controls;
}
